"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawYLabelConnector = exports.drawYValueLabels = exports.measureYLabels = void 0;
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const chart_helpers_1 = require("../../util/chart.helpers");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const AXIS_PADDING = 10;
const X_AXIS_PADDING = AXIS_PADDING * 2;
const getTextHeight = function (texts, fontSize) {
  let padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return fontSize + (texts.length - 1) * (fontSize + 2 * padding);
};
const measureYLabels = (yValueLabels, maxWidth, fontSize) => {
  const fontStyle = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
  const labels = Object.values(yValueLabels);
  const yTicks = labels.flatMap(label => (0, chart_helpers_1.breakLines)(label, maxWidth, fontStyle, 3));
  const context = (0, canvas_1.createCanvas)(300, 300).getContext('2d');
  context.font = fontStyle;
  return lodash_1.default.max(yTicks.map(tick => context.measureText(tick).width)) + AXIS_PADDING;
};
exports.measureYLabels = measureYLabels;
const getYValueLabels = (_ref, dataPoints) => {
  let {
    params: {
      yValueLabels,
      yValueExtraLabels
    }
  } = _ref;
  const allValueLabels = {
    ...yValueLabels
  };
  if (yValueExtraLabels) {
    const maxValue = lodash_1.default.max(dataPoints.map(d => d.value));
    const yValueExtraValues = Object.keys(yValueExtraLabels).map(k => Number(k));
    let closestHigherValue = lodash_1.default.min(yValueExtraValues.filter(k => k >= maxValue));
    if (closestHigherValue === undefined) {
      closestHigherValue = lodash_1.default.max(yValueExtraValues);
    }
    yValueExtraValues.filter(k => k <= closestHigherValue).forEach(k => {
      allValueLabels[k] = yValueExtraLabels[k];
    });
  }
  return allValueLabels;
};
function drawYValueLabels(drawParams, xScale, yScale) {
  let padding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  const {
    params: {
      fontSize,
      yValueLabels,
      boldValueLabels
    }
  } = drawParams;
  const fontStyle = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
  const allValueLabels = getYValueLabels(drawParams, this.allDataPoints);
  const labels = Object.values(allValueLabels).map(label => (0, chart_helpers_1.breakLines)(label, this.maxYAxisOffset(), fontStyle, 3).filter(l => l.length > 0));
  const yLabelPositions = Object.keys(allValueLabels);
  const labelData = labels.flatMap((texts, i) => texts.map((text, j) => ({
    id: `${i}-${j}`,
    yValue: yLabelPositions[i],
    index: j,
    text,
    texts,
    textHeight: getTextHeight(texts, fontSize),
    bold: boldValueLabels && Number(yValueLabels[yLabelPositions[i]]) !== Number(yLabelPositions[i])
  })));
  this.group.select('.axis.y-labels').selectAll('rect.y-label-back').data(labelData, d => d.id).join('rect').classed('y-label-back', true).attr('x', xScale.range()[0] - X_AXIS_PADDING - 5).attr('y', d => {
    const centerY = yScale(d.yValue);
    return centerY - d.textHeight / 2 - fontSize / 2 + d.index * (fontSize + 2 * padding);
  }).attr('width', 10).attr('height', fontSize * 2);
  this.group.select('.axis.y-labels').selectAll('text.y-label').data(labelData, d => d.id).join('text').classed('y-label', true).attr('x', xScale.range()[0] - X_AXIS_PADDING).attr('y', d => {
    const centerY = yScale(d.yValue);
    return centerY - d.textHeight / 2 + fontSize / 2 + d.index * (fontSize + 2 * padding);
  }).style('font-size', `${fontSize}px`).style('font-weight', d => d.bold ? 'bold' : null).style('opacity', d => d.bold ? 0.8 : 1)
  // default dy for left axis
  .attr('dy', '0.32em').text(d => d.text);
}
exports.drawYValueLabels = drawYValueLabels;
function drawYLabelConnector(drawParams, xScale, yScale) {
  const [yStart, yEnd] = yScale.range();
  const allValueLabels = getYValueLabels(drawParams, this.allDataPoints);
  this.group.select('.axis.y-labels').selectAll('line.axis-connector').data([xScale.range()[0] - X_AXIS_PADDING - 3]).join('line').classed('axis-connector', true).attr('x1', d => d).attr('y1', allValueLabels ? yScale(lodash_1.default.maxBy(Object.keys(allValueLabels), d => Number(d))) : yEnd).attr('x2', d => d).attr('y2', yStart);
}
exports.drawYLabelConnector = drawYLabelConnector;